import React, { useEffect, useState } from 'react';
import BouncingDots from './BouncingDots';

interface SplashScreenProps {
  onComplete: () => void;
  duration?: number; // in milliseconds
}

const SplashScreen: React.FC<SplashScreenProps> = ({ 
  onComplete, 
  duration = 3000 
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onComplete, 500);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onComplete]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-white via-gray-100 to-gray-200">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 opacity-10 animate-pulse"></div>
      
      {/* Iridescent glass effect container */}
      <div className="relative z-10 bg-white/80 backdrop-blur-md rounded-3xl p-12 shadow-2xl border border-white/20">
        {/* Animated border gradient */}
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 opacity-20 animate-spin-slow"></div>
        
        {/* Content */}
        <div className="relative z-20 text-center">
          {/* Main title with gradient text */}
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent animate-pulse">
            Scan To Pay
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg md:text-xl text-gray-600 font-medium">
            Parking Made Simple
          </p>
          
          <div className="mt-8">
            <BouncingDots />
          </div>
        </div>
      </div>
      
      {/* Floating particles effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-blue-400 rounded-full opacity-30 animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default SplashScreen; 